import React from 'react';
import { LuVariable } from 'react-icons/lu';

function VariableIcon({ size }: { size?: number }) {
  // return (
  //   <svg
  //     width="19"
  //     height="21"
  //     viewBox="0 0 19 21"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //     className="tw-w-6 tw-h-6 tw-relative tw-text-gray-800"
  //   >
  //     <path
  //       d="M15.5 0.5H3.5C1.57 0.5 0 2.07 0 4V20.5L7 17L14 20.5V11.5H19V4C19 2.07 17.43 0.5 15.5 0.5ZM12 17.264L7 14.764L2 17.264V4C2 3.173 2.673 2.5 3.5 2.5H12.352C12.1231 2.96708 12.0028 3.47986 12 4V17.264ZM17 9.5H14V4C14 3.173 14.673 2.5 15.5 2.5C16.327 2.5 17 3.173 17 4V9.5Z"
  //       fill="black"
  //     />
  //   </svg>
  // );
  return <LuVariable size={size} />;
}

export default VariableIcon;
